import React from 'react';
import { ValuationsContextValues } from './types';
import { VALUATIONS_DEFAULT_CURRENCY } from '../../common/constants/valuations';

const ValuationContext = React.createContext<ValuationsContextValues>({
  approaches: null,
  backsolveAttributes: null,
  companyMeasurementDate: null,
  compGroups: null,
  disableFinancialsSelection: null,
  filesInApproach: null,
  financials: null,
  financialsPeriods: null,
  financialStatementPeriods: null,
  financialsVersions: null,
  gpcAttributes: null,
  calibrationAttributes: null,
  isChangingFinancialStatement: null,
  isEditingApproachName: null,
  isEditingCalibrationName: false,
  marketCurrency: VALUATIONS_DEFAULT_CURRENCY,
  marketDate: '',
  measurementDate: null,
  notesInApproach: null,
  onChange: null,
  publicCompsAttrs: null,
  resetConfiguration: null,
  selectedFinancialsVersion: null,
  setAreThereChanges: null,
  setCashTaxRate: () => {},
  setFilesInApproach: null,
  setNotesInApproach: null,
  valuation: null,
  workbook: null,
  allocationMethodsOptions: [],
  updateApproachesScenarioMethods: () => {},
  financialStatementPeriodsPerMD: [],
});

export default ValuationContext;
